import React from 'react';
import clsx from 'clsx';
import styles from './MetricsGrid.module.css';

export interface MetricsGridProps {
  children: React.ReactNode;
  className?: string;
}

const MetricsGrid: React.FC<MetricsGridProps> = ({ children, className }) => {
  return <div className={clsx(styles.grid, className)}>{children}</div>;
};

export default MetricsGrid;
